import lodash from 'lodash'
import Base from '../base.store'

const baseUrl = '/api/v1/transaction/inform-products'
const base = new Base(baseUrl)

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {}),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        searchUsedInvoices(context, { data, config }) {
            return base.request.post(`${baseUrl}/search/used-invoices`, data, { ...config });
        }
    },
    mutations: {
        ...base.mutations
    },
}
